import { useState, useCallback } from 'react';
import { STORAGE_KEYS, API_BASE_URL } from '../utils/constants';

export const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const request = useCallback(async (endpoint, options = {}) => {
    setLoading(true);
    setError(null);

    const url = `${API_BASE_URL}${endpoint}`;

    try {
      const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
      
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        ...options.headers,
      };

      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(url, {
        ...options,
        headers,
      });

      // Obtener el texto de la respuesta primero
      const text = await response.text();
      
      // Intentar parsear como JSON
      let data;
      try {
        data = JSON.parse(text);
      } catch (parseError) {
        throw new Error(`Error del servidor: ${response.status}. Respuesta no válida.`);
      }

      if (!response.ok) {
        throw new Error(data.message || `Error ${response.status}: ${response.statusText}`);
      }

      // El backend retorna { success: true, data: {...}, message: null }
      // Extraemos solo la propiedad data del backend
      return { success: true, data: data.data };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  }, []);

  const get = useCallback((endpoint, options = {}) => {
    return request(endpoint, { ...options, method: 'GET' });
  }, [request]);

  const post = useCallback((endpoint, body, options = {}) => {
    return request(endpoint, { 
      ...options, 
      method: 'POST', 
      body: JSON.stringify(body) 
    });
  }, [request]);

  const put = useCallback((endpoint, body, options = {}) => {
    return request(endpoint, { 
      ...options, 
      method: 'PUT', 
      body: JSON.stringify(body) 
    });
  }, [request]);

  const del = useCallback((endpoint, options = {}) => {
    return request(endpoint, { ...options, method: 'DELETE' });
  }, [request]);

  return {
    loading,
    error,
    setError,
    request,
    get,
    post,
    put,
    del,
  };
};

export default useApi;
